import { parseTeamToRankingRequest } from '@features/rankings/parsers/team-ranking.parser'
import { parseTeamComparisonToRankingRequest } from '@features/rankings/parsers/team-comparison-ranking.parser'
import { TeamHolder } from '@pages/team/models/team.models'
import { ContextMenuItemEvent } from '@core/models/context-menu.models'
import { getMetricValueAndContext } from '@core/utils/context-menu.utils'
import { Aggregation, AggregationContext } from '@features/aggregations/models/aggregations.models'

export const resolveTeamRankingRequestAdapter = (
  payload: ContextMenuItemEvent,
  aggregationMode: Aggregation,
  { isVsEnabled }: AggregationContext
) => {
  const { context, value, mode } = getMetricValueAndContext<TeamHolder>(payload, aggregationMode)

  return isVsEnabled
    ? parseTeamComparisonToRankingRequest(context.comparison, value, mode)
    : parseTeamToRankingRequest(context.team, value, mode)
}
